module.exports = __webpack_public_path__ + "939146bca28ac5d8bf205ab63741c30f.svg";